<template>
    <CieloLayout>
        <router-view v-if="!loading" />

        <div class="row" v-if="loading">
            <MoonLoader color="#00AEEF" size="70px" class="loader mx-auto mt-5 mb-4" />
        </div>
    </CieloLayout>
</template>

<script>
    import loader from '@/helpers/loader';
    import MoonLoader from 'vue-spinner/src/MoonLoader';
    import CieloLayout from '../../components/layout/CieloLayout.vue';

    export default {
        components: {
            MoonLoader,
            CieloLayout,
        },

        async created() {
            loader.multiLanguage = this.$ml;
            this.loading = true;
            if (this.hasCards) {
                this.$store.dispatch('pipelineV2/pushTo', 'CardListC2P');
            } else if (this.consumerPresent) {
                this.$store.dispatch('pipelineV2/pushTo', 'UnifiedCardPaymentC2P');
            }
            this.loading = false;
        },

        data() {
            return {
                loading: false,
            };
        },

        computed: {
            hasCards() {
                const cards = this.$store.state.clickToPayPayment.cards;
                return cards !== null && cards.length > 0;
            },
            consumerPresent() {
                return this.$store.state.clickToPayPayment.consumerPresent;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .payment-type-title {
        color: #34454F;
        font-size: 16px;
        font-weight: 500;
    }

    .payment-type {
        border-radius: 8px;
        border: 1px solid #C5CED7;
        background: #FFFFFF;
        padding: 15px;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }

        height: 64px;
    }

    .payment-type-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 100%;

        p {
            width: 60%;
            font-size: 16px;
            color: #231F20;
            margin: 0;
            flex: 1
        }
    }

    .payment-type-img-wrapper {
        width: 50px;
        margin-right: 10px;
    }

    .loader {
        display: block;
        width: 70px;
        height: 70px;
    }
</style>
